import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuthState } from 'react-admin';
import { httpClient } from '../config/httpClient';
import {
  getSelectedIndustryId,
  setSelectedIndustryId,
  clearIndustryScopedCache,
} from '../utils/industryUtils';

const IndustryContext = createContext(null);

export const IndustryProvider = ({ children }) => {
  const [industries, setIndustries] = useState([]);
  const [industryId, setIndustryId] = useState(getSelectedIndustryId());
  const [loading, setLoading] = useState(true);
  const { authenticated } = useAuthState();

  useEffect(() => {
    if (!authenticated) {
      setLoading(false);
      return;
    }

    const fetchIndustries = async () => {
      try {
        const { json } = await httpClient('/get-industries-list');
        setIndustries(json);
        if (!industryId && json.length > 0) {
          setSelectedIndustryId(json[0].id);
          setIndustryId(json[0].id);
        }
      } catch (error) {
        console.error('Failed to fetch industries:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchIndustries();
  }, [authenticated]);

  const switchIndustry = useCallback((newIndustryId) => {
    const id = parseInt(newIndustryId, 10);
    setSelectedIndustryId(id);
    setIndustryId(id);
    clearIndustryScopedCache();
    localStorage.removeItem('RaStore.theme');
    window.location.reload();
  }, []);

  return (
    <IndustryContext.Provider value={{ industries, industryId, switchIndustry, loading }}>
      {children}
    </IndustryContext.Provider>
  );
};

export const useIndustry = () => {
  const context = useContext(IndustryContext);
  if (!context) {
    throw new Error('useIndustry must be used within an IndustryProvider');
  }
  return context;
};
